export const namespaceLabel = (slot: number, label: string): string => {
  return `${slot}:${label}`;
};

export const displayNamespacedLabel = (label: string): string => {
  const labelParts = label.split(':');
  return labelParts.length > 1 ? labelParts[1] : labelParts[0];
};
